module.exports = __webpack_public_path__ + "static/media/HCMM123.a0ebd7c4.jpg";